module.exports = __webpack_public_path__ + "static/img/avatar_default.250017d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/share/avatar_default.png
// module id = l8CZ
// module chunks = 3 6